import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router';

const buttonLikeCss = css`
  text-decoration: none;
  border: none;
  vertical-align: middle;
  cursor: pointer;
  transition: filter 0.2s ease, background-color 0.2s ease;

  flex: 0 1 auto;
  border-radius: ${rem(4)};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.color.white};
  font-family: ${({ theme }) => theme.font.primary};
  height: ${rem(48)};

  font-size: ${rem(16)};
  line-height: ${rem(19)};
  font-weight: 600;
  letter-spacing: 0;

  display: inline-flex;
  justify-content: center;
  align-items: center;

  padding: ${rem(12)} ${rem(24)};

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.colors.inactiveFontColor};
    color: ${({ theme }) => theme.color.white};

    &:hover,
    &:focus {
      filter: brightness(100%);
    }
  }

  &:hover,
  &:focus {
    outline: none;
  }

  // ${({ theme }) => theme.mediab.s450`
  //   max-width: ${rem(288)};
  // `}
`;

export const Button: any = styled.button`
  ${buttonLikeCss};
`;

export const ButtonSecondary: any = styled(Button)`
  background: ${({ theme }) => theme.colors.secondary};
`;

export const ButtonLink: any = styled(Link)`
  ${buttonLikeCss};
`;

export const ButtonLinkSecondary: any = styled(ButtonLink)`
  background: ${({ theme }) => theme.colors.secondary};
`;
